<template>
  <v-card class="upload-card" flat>
    <v-card-title class="upload-card__title">Import file</v-card-title>
    <v-card-text v-if="!isLoading">
      <v-file-input
        show-size
        outlined
        dense
        prepend-icon=""
        prepend-inner-icon="mdi-paperclip"
        label="File"
        @change="selectFile"
      ></v-file-input>
    </v-card-text>

    <v-card-actions v-if="!isLoading" class="upload-card__actions">
      <v-btn type="button" text @click="close()">Close</v-btn>
      <v-spacer></v-spacer>
      <v-btn type="button" color="primary" depressed :disabled="!selectedFile" @click="upload()">Upload</v-btn>
    </v-card-actions>

    <div v-if="isLoading" class="upload-card__loader">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </v-card>
</template>

<script>
import { toBase64 } from '@/helpers';
import { authHeader } from '@/helpers';

export default {
  props: ['url', 'ignoreStock'],
  data: () => ({
    selectedFile: null,
    isLoading: false
  }),
  methods: {
    close: function() {
      this.$emit('close');
    },

    selectFile: function(file) {
      this.selectedFile = file;
    },

    upload: async function() {
      this.isLoading = true;
      var base64 = await toBase64(this.selectedFile);
      var dto = {
        base64: base64,
        ignoreStock: this.ignoreStock
      }

      const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(dto)
      };

      var response = await fetch(`${process.env.VUE_APP_APIURL}${this.url}`, requestOptions)
      this.isLoading = false;
      if (response.status != 200) {
        alert("Error importing");
        return;
      }

      this.$emit('success');
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-card {
  background: #ffffff;
  padding: 4px;
}

.upload-card__title {
  color: #111827;
  font-size: 18px;
  font-weight: 800;
  padding-bottom: 8px;
}

.upload-card__actions {
  padding: 0 16px 16px;
}

.upload-card__loader {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 180px;
}
</style>
